import Dashboard from "views/Dashboard.js";
import Login from "views/pages/Login.js";
import ConfigurationList from "views/pages/configurations/List";
import ConfigurationContent from "views/pages/configurations/Content";
import SubscriberList from "views/pages/subscribers/SubscriberList";
import AlarmList from "views/pages/alarms/AlarmList";
import FirmwareUpload from "views/pages/firmwares/Upload";
import VersionUpload from "views/pages/versions/Upload";
import VersionsList from "views/pages/versions/List";
import Maintenance from "views/pages/Maintenance";
import LicensesList from "views/pages/versions/Licenses";
import Terms from "views/pages/Terms.js";
import GroupList from "views/pages/groups/GroupList";
import GroupEdit from "views/pages/groups/GroupEdit";
import BandwidthList from "views/pages/bandwidths/BandwidthList";
import BandwidthEdit from "views/pages/bandwidths/BandwidthEdit";
import DeviceDetails from "views/pages/devices/DeviceDetails";
import EndpointList from "views/pages/endpoints/EndpointList";
import DeviceList from "views/pages/devices/DeviceList";
import EndpointDetails from "views/pages/endpoints/EndpointDetails";
import TimezoneList from "views/pages/timezones/TimezoneList";
import NtpEdit from "views/pages/timezones/NtpEdit";
import TimezoneEdit from "views/pages/timezones/TimezoneEdit";
import SubscriberEdit from "views/pages/subscribers/SubscriberEdit";
import SubscriberImport from "views/pages/subscribers/SubscriberImport";
import SubscriberDetails from "views/pages/subscribers/SubscriberDetails";
import DeviceUrlAnnouncement from "views/pages/devices/DeviceUrlAnnouncement";
import FirmwaresList from "views/pages/firmwares/FirmwareList";
import CertificateUpload from "views/pages/versions/CertificateUpload";
import FirmwareUpgrade from "views/pages/automations/FirmwareUpgrade";
import GamConfigurationList from "views/pages/automations/GamConfigurationList";
import GamConfigurationEdit from "views/pages/automations/GamConfigurationEdit";
import SiteList from "views/pages/installations/SiteList";
import SiteEdit from "views/pages/installations/SiteEdit";
import ProfileList from "views/pages/installations/ProfileList";
import SiteDetails from "views/pages/installations/SiteDetails";
import RoomImport from "views/pages/installations/RoomImport";
import ProfileEdit from "views/pages/installations/ProfileEdit";
import RoomEdit from "views/pages/installations/RoomEdit";
import EndpointSpectrum from "views/pages/endpoints/EndpointSpectrum";
import RoomDetails from "views/pages/installations/RoomDetails";
import RoomImages from "views/pages/installations/RoomImages";
import SessionList from "views/pages/sessions/List";
import LogsHistory from "views/pages/logs/history";
import UserList from "views/pages/users/UserList";
import UserEdit from "views/pages/users/UserEdit";
import SettingEdit from "views/pages/settings/SettingEdit";
import Auditing from "views/pages/auditing/List";
import NotificationList from "views/pages/notifications/NotificationList";
import PortList from "views/pages/ports/PortList";
import SubscriberEditConfirm from "views/pages/subscribers/SubscriberEditConfirm";
import TaskList from "views/pages/tasks/TaskList";
import CertificatePage from "views/pages/versions/CertificatePage";
import Acknowledgements from "views/pages/versions/Acknowledgements";

const routes = [
  {
    collapse: true,
    name: "Monitoring",
    icon: "chart-line",
    state: "monitoringCollapse",
    visible: true,
    privilegeKey: "devices.display",
    license: false,
    views: [
      {
        path: "/dashboard",
        name: "Dashboard",
        mini: "D",
        state: "monitoringCollapse",
        component: Dashboard,
        layout: "/admin",
        visible: true,
        privilegeKey: "dashboard.display",
        license: false,
      },
      {
        path: "/alarms/list",
        name: "Alarms",
        mini: "A",
        state: "monitoringCollapse",
        component: AlarmList,
        layout: "/admin",
        visible: true,
        privilegeKey: "alarms.display",
        license: false,
      },
    ],
  },
  {
    collapse: true,
    name: "Services",
    icon: "users-gear",
    state: "servicesCollapse",
    visible: true,
    privilegeKey: "devices.display",
    license: false,
    views: [
      {
        path: "/subscribers/list",
        name: "Subscribers",
        mini: "S",
        component: SubscriberList,
        layout: "/admin",
        visible: true,
        privilegeKey: "devices.subscribers.display",
        license: false,
      },
      {
        path: "/bandwidths/list",
        name: "Bandwidths",
        mini: "B",
        component: BandwidthList,
        layout: "/admin",
        visible: true,
        privilegeKey: "devices.bandwidths.display",
        license: false,
      },
      {
        path: "/subscribers/edit",
        name: "Subscriber Edit",
        mini: "SE",
        component: SubscriberEdit,
        layout: "/admin",
        visible: false,
        privilegeKey: "devices.subscribers.edit",
        license: false,
      },
      {
        path: "/subscribers/edit/confirm",
        name: "Subscriber Edit Confirm",
        mini: "SEC",
        component: SubscriberEditConfirm,
        layout: "/admin",
        visible: false,
        privilegeKey: "devices.subscribers.edit",
        license: false,
      },
      {
        path: "/subscribers/import",
        name: "Subscriber Import",
        mini: "SI",
        component: SubscriberImport,
        layout: "/admin",
        visible: false,
        privilegeKey: "devices.subscribers.create",
        license: false,
      },
      {
        path: "/subscribers/details",
        name: "Details",
        mini: "D",
        component: SubscriberDetails,
        layout: "/admin",
        visible: false,
        privilegeKey: "devices.subscribers.details.display",
        license: false,
      },
      {
        path: "/installations/profile/list",
        name: "Profiles",
        mini: "P",
        component: ProfileList,
        layout: "/admin",
        visible: true,
        privilegeKey: "installations.site.list",
        license: true,
        licenseType: "pro",
      },
      {
        path: "/installations/profile/edit",
        name: "Profiles",
        mini: "P",
        component: ProfileEdit,
        layout: "/admin",
        visible: false,
        privilegeKey: "installations.site.edit",
        license: true,
        licenseType: "pro",
      },
    ],
  },
  {
    collapse: true,
    name: "Automations",
    icon: "gears",
    state: "automationCollapse",
    visible: true,
    privilegeKey: "automations.display",
    license: true,
    licenseType: "pro",
    views: [
      {
        path: "/automations/firmware/upgrade",
        name: "Firmware Upgrade",
        mini: "FU",
        component: FirmwareUpgrade,
        layout: "/admin",
        visible: true,
        privilegeKey: "automations.firmware.upgrade.edit",
        license: true,
        licenseType: "pro",
      },
      {
        path: "/automations/configuration/list",
        name: "GAM Provisioning",
        mini: "GP",
        component: GamConfigurationList,
        layout: "/admin",
        visible: true,
        privilegeKey: "automations.gam.configuration.display",
        license: true,
        licenseType: "pro",
      },
      {
        path: "/automations/configuration/edit",
        name: "GAM Configurations Edit",
        mini: "GCE",
        component: GamConfigurationEdit,
        layout: "/admin",
        visible: false,
        privilegeKey: "automations.gam.configuration.edit",
        license: true,
        licenseType: "pro",
      },
      {
        path: "/installations/site/list",
        name: "Endpoint Provisioning",
        mini: "EP",
        component: SiteList,
        layout: "/admin",
        visible: true,
        privilegeKey: "installations.site.list",
        license: true,
        licenseType: "pro",
      },
      {
        path: "/installations/site/edit",
        name: "Sites",
        mini: "S",
        component: SiteEdit,
        layout: "/admin",
        visible: false,
        privilegeKey: "installations.site.edit",
        license: true,
        licenseType: "pro",
      },
      {
        path: "/installations/site/endpoint/import",
        name: "Endpoint Import",
        mini: "RI",
        component: RoomImport,
        layout: "/admin",
        visible: false,
        privilegeKey: "installations.site.edit",
        license: true,
        licenseType: "pro",
      },
      {
        path: "/installations/site/details",
        name: "Site Details",
        mini: "D",
        component: SiteDetails,
        layout: "/admin",
        visible: false,
        privilegeKey: "installations.site.list",
        license: true,
        licenseType: "pro",
      },
      {
        path: "/installations/site/endpoint/details",
        name: "Endpoint Details",
        mini: "RD",
        component: RoomDetails,
        layout: "/admin",
        visible: false,
        privilegeKey: "installations.site.edit",
        license: true,
        licenseType: "pro",
      },
      {
        path: "/installations/site/endpoint/details/images",
        name: "Endpoint Details Images",
        mini: "RDI",
        component: RoomImages,
        layout: "/admin",
        visible: false,
        privilegeKey: "installations.site.edit",
        license: true,
        licenseType: "pro",
      },
      {
        path: "/installations/site/details",
        name: "Site Details",
        mini: "D",
        component: SiteDetails,
        layout: "/admin",
        visible: false,
        privilegeKey: "installations.site.list",
        license: true,
        licenseType: "pro",
      },
      {
        path: "/installations/site/endpoint/edit",
        name: "Endpoint Edit",
        mini: "RE",
        component: RoomEdit,
        layout: "/admin",
        visible: false,
        privilegeKey: "installations.site.edit",
        license: true,
        licenseType: "pro",
      },
    ],
  },
  {
    collapse: true,
    name: "Devices",
    icon: "laptop",
    state: "devicesCollapse",
    visible: true,
    privilegeKey: "devices.display",
    license: false,
    views: [
      {
        path: "/devices/list",
        name: "GAM",
        mini: "G",
        component: DeviceList,
        layout: "/admin",
        visible: true,
        privilegeKey: "devices.display",
        license: false,
      },
      {
        path: "/devices/details",
        name: "Details",
        mini: "D",
        component: DeviceDetails,
        layout: "/admin",
        visible: false,
        privilegeKey: "devices.details.display",
        license: false,
      },
      {
        path: "/configurations/list",
        name: "Configurations",
        mini: "C",
        component: ConfigurationList,
        layout: "/admin",
        visible: false,
        privilegeKey: "devices.configurations.display",
        license: false,
      },
      {
        path: "/configurations/content",
        name: "Configurations content",
        mini: "CC",
        component: ConfigurationContent,
        layout: "/admin",
        visible: false,
        privilegeKey: "devices.configurations.content.display",
        license: false,
      },
      {
        path: "/ports/list",
        name: "Ports",
        mini: "P",
        component: PortList,
        layout: "/admin",
        visible: false,
        privilegeKey: "devices.ports.display",
        license: false,
      },
      {
        path: "/endpoints/list",
        name: "Endpoints",
        mini: "E",
        component: EndpointList,
        layout: "/admin",
        visible: true,
        privilegeKey: "devices.endpoints.display",
        license: false,
      },
      {
        path: "/endpoints/details",
        name: "Details",
        mini: "D",
        component: EndpointDetails,
        layout: "/admin",
        visible: false,
        privilegeKey: "devices.endpoints.details.display",
        license: false,
      },
      {
        path: "/endpoints/spectrum",
        name: "Spectrum",
        mini: "S",
        component: EndpointSpectrum,
        layout: "/admin",
        visible: false,
        privilegeKey: "devices.endpoints.details.display",
        license: false,
      },
      {
        path: "/bandwidths/edit",
        name: "Bandwidths Edit",
        mini: "BE",
        component: BandwidthEdit,
        layout: "/admin",
        visible: false,
        privilegeKey: "devices.bandwidths.edit",
        license: false,
      },
      {
        path: "/groups/list",
        name: "Groups",
        mini: "G",
        component: GroupList,
        layout: "/admin",
        visible: true,
        privilegeKey: "devices.groups.display",
        license: false,
      },
      {
        path: "/groups/edit",
        name: "Group Edit",
        mini: "GE",
        component: GroupEdit,
        layout: "/admin",
        visible: false,
        privilegeKey: "devices.groups.edit",
        license: false,
      },
      {
        path: "/timezones/list",
        name: "Timezones",
        mini: "T",
        component: TimezoneList,
        layout: "/admin",
        visible: true,
        privilegeKey: "devices.timezones.display",
        license: false,
      },
      {
        path: "/devices/urlannouncement",
        name: "Url Announcement",
        mini: "UA",
        component: DeviceUrlAnnouncement,
        layout: "/admin",
        visible: false,
        privilegeKey: "devices.url.announcement",
        license: true,
        licenseType: "pro",
      },
      {
        path: "/timezones/ntp",
        name: "NTP Server",
        mini: "N",
        component: NtpEdit,
        layout: "/admin",
        visible: false,
        privilegeKey: "devices.timezones.ntp.edit",
        license: false,
      },
      {
        path: "/timezones/edit",
        name: "Timezone Edit",
        mini: "T",
        component: TimezoneEdit,
        layout: "/admin",
        visible: false,
        privilegeKey: "devices.timezones.edit",
        license: false,
      },
      {
        path: "/firmwares/list",
        name: "Firmware Versions",
        mini: "FV",
        component: FirmwaresList,
        layout: "/admin",
        visible: true,
        privilegeKey: "firmwares.display",
        license: false,
      },
      {
        path: "/firmwares/upload",
        name: "Add Version",
        mini: "A",
        component: FirmwareUpload,
        layout: "/admin",
        visible: true,
        privilegeKey: "firmwares.upload.display",
        license: false,
      },
    ],
  },
  {
    collapse: true,
    name: "Virtuoso Versions",
    icon: "bookmark",
    state: "virtuosoCollapse",
    visible: true,
    privilegeKey: "versions.display",
    license: false,
    views: [
      {
        path: "/version/list",
        name: "List",
        mini: "L",
        component: VersionsList,
        layout: "/admin",
        visible: true,
        privilegeKey: "versions.list.display",
        license: false,
      },
      {
        path: "/version/upload",
        name: "Upload",
        mini: "U",
        component: VersionUpload,
        layout: "/admin",
        visible: true,
        privilegeKey: "versions.upload.display",
        license: false,
      },
      {
        path: "/version/licenses",
        name: "Licenses",
        mini: "L",
        component: LicensesList,
        layout: "/admin",
        visible: true,
        privilegeKey: "versions.licenses.display",
        license: false,
      },
      {
        path: "/version/certificates/upload",
        name: "Certificates",
        mini: "C",
        component: CertificateUpload,
        layout: "/admin",
        visible: true,
        privilegeKey: "versions.certificates.upload",
        license: false,
      },
    ],
  },
  {
    collapse: true,
    name: "Admin",
    icon: "suitcase",
    state: "adminCollapse",
    visible: true,
    privilegeKey: "admin.display",
    license: false,
    views: [
      {
        path: "/sessions/list",
        name: "Active Sessions",
        mini: "AS",
        component: SessionList,
        layout: "/admin",
        visible: true,
        privilegeKey: "admin.sessions.display",
        license: false,
      },
      {
        path: "/logs/history",
        name: "Logs",
        mini: "L",
        component: LogsHistory,
        layout: "/admin",
        visible: true,
        privilegeKey: "admin.logs.display",
        license: false,
      },
      {
        path: "/users/list",
        name: "Users",
        mini: "U",
        component: UserList,
        layout: "/admin",
        visible: true,
        privilegeKey: "admin.users.display",
        license: false,
      },
      {
        path: "/users/edit",
        name: "User Edit",
        mini: "UE",
        component: UserEdit,
        layout: "/admin",
        visible: false,
        privilegeKey: "admin.users.edit",
        license: false,
      },
      {
        path: "/settings/edit",
        name: "Settings",
        mini: "S",
        component: SettingEdit,
        layout: "/admin",
        visible: true,
        privilegeKey: "admin.settings.display",
        license: false,
      },
      {
        path: "/auditing/list",
        name: "Auditing",
        mini: "A",
        component: Auditing,
        layout: "/admin",
        visible: true,
        privilegeKey: "admin.auditing.display",
        license: false,
      },
      {
        path: "/notification/list",
        name: "Notifications",
        mini: "N",
        component: NotificationList,
        layout: "/admin",
        visible: true,
        privilegeKey: "notifications.display",
        license: false,
      },
      {
        path: "/tasks/list",
        name: "Scheduled Tasks",
        mini: "ST",
        component: TaskList,
        layout: "/admin",
        visible: true,
        privilegeKey: "tasks.display",
        license: false,
      },
    ],
  },
  {
    path: "/alarms/severity",
    name: "Alarms Severity",
    component: AlarmList,
    layout: "/admin",
    visible: false,
    privilegeKey: "alarms.display",
    license: false,
  },
  {
    path: "/certificate",
    name: "Certificate",
    mini: "C",
    component: CertificatePage,
    layout: "/auth",
    visible: false,
    privilegeKey: "versions.licenses.display",
    license: false,
  },
  {
    path: "/acknowledgements",
    name: "Acknowledgements",
    mini: "a",
    component: Acknowledgements,
    layout: "/admin",
    visible: false,
    privilegeKey: "versions.licenses.display",
    license: false,
  },
  {
    path: "/login",
    name: "Login",
    mini: "L",
    component: Login,
    layout: "/auth",
    visible: false,
    privilegeKey: "login.display",
    license: false,
  },
  {
    path: "/maintenance",
    name: "Maintenance",
    mini: "M",
    component: Maintenance,
    layout: "/admin",
    visible: false,
    privilegeKey: "maintenance.display",
    license: false,
  },
  {
    path: "/terms",
    name: "Terms",
    mini: "T",
    component: Terms,
    layout: "/auth",
    visible: false,
    privilegeKey: "terms.display",
    license: false,
  },
  {
    path: "/login",
    name: "Logout",
    icon: "sign-out",
    mini: "L",
    component: Login,
    layout: "/auth",
    visible: true,
    privilegeKey: "logout.display",
    license: false,
  },
];

export default routes;
